export const GET_APP_LINK = 'https://depop.app.link/get-the-app';
export const APP_STORE_URL = 'https://apps.apple.com/app/id518684914';
export const PLAY_STORE_URL =
  'https://play.google.com/store/apps/details?id=com.depop';
